const { InspectorControls } = wp.blockEditor;
const { PanelBody, TextControl, ToggleControl, SelectControl } = wp.components;
import ImageControl from '../wp-controlers/mediaUpload';
import CommonPanel from '../wp-controlers/common-panel';

const Inspector = ({ attributes, setAttributes }) => {
  const {
    hrefLink,
    smallTitle,
    hideButton,
    containerized,
    imagePosition,
    space,
    addTitle,
    addImage,
    addButton,
  } = attributes;

  return (
    <InspectorControls>
      <PanelBody title={'Atributos do Grid'} initialOpen={true}>
        <ToggleControl
          label="Este titulo está fora de um container?"
          checked={containerized}
          onChange={() => setAttributes({ containerized: !containerized })}
        />

        <ToggleControl
          label="Adicionar título a seção"
          checked={addTitle}
          onChange={() => setAttributes({ addTitle: !addTitle })}
        />

        <ToggleControl
          label="Adicionar imagem a seção"
          checked={addImage}
          onChange={() => setAttributes({ addImage: !addImage })}
        />

        <ToggleControl
          label="Adicionar botão a seção"
          checked={addButton}
          onChange={() => setAttributes({ addButton: !addButton })}
        />

        {addImage && (
          <>
            <ImageControl
              image="image"
              attributes={attributes}
              setAttributes={setAttributes}
            />

            <SelectControl
              label="Selecione a posição do conteúdo"
              title="Selecione a posição do conteúdo"
              value={imagePosition}
              options={[
                { label: 'Direita', value: 'right' },
                { label: 'Esquerda', value: 'left' },
              ]}
              onChange={(position) =>
                setAttributes({ imagePosition: position })
              }
            />

            <SelectControl
              label="Selecione o espaço entre a imagem e os cards"
              title="Selecione o espaço entre a imagem e os cards"
              value={space}
              options={[
                { label: 'Pequeno', value: 'small' },
                { label: 'Grande', value: 'large' },
              ]}
              onChange={(position) => setAttributes({ space: position })}
            />
          </>
        )}

        {addButton && (
          <>
            <TextControl
              label={'URL do Botão'}
              value={hrefLink}
              onChange={(hrefLink) => setAttributes({ hrefLink })}
            />

            <ToggleControl
              label={'Não exibir botão mobile'}
              help={
                smallTitle
                  ? 'Remover o botão que seria exibido em versões mobile'
                  : 'Manter o botão que seria exibido em versões mobile'
              }
              checked={hideButton}
              onChange={(hideButton) => {
                setAttributes({ hideButton });
              }}
            />
          </>
        )}
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
